import { render, staticRenderFns } from "./LoginBefore.vue?vue&type=template&id=28b608b1&scoped=true&"
import script from "./LoginBefore.vue?vue&type=script&lang=js&"
export * from "./LoginBefore.vue?vue&type=script&lang=js&"
import style0 from "./LoginBefore.vue?vue&type=style&index=0&id=28b608b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b608b1",
  null
  
)

component.options.__file = "LoginBefore.vue"
export default component.exports